import React from 'react';
import { Button } from '../Button';
import { Content } from './styles';

interface IValoresProps {
  nome: string;
  setMensagemLocal: (value: string) => void;
  envioMensagem: () => void;
}

function InputEnviar({ nome, setMensagemLocal, envioMensagem }: IValoresProps) {
  return (
    <Content>
      <div id="box">
        <div id="textBox">
          <input
            type="text"
            value={nome}
            onChange={(e) => setMensagemLocal(e.target.value)}
            id="escreve"
            placeholder="Escreva sua mensagem aqui..."
            onKeyDown={(e) => {
              if (e.nativeEvent.code === 'Enter') {
                envioMensagem();
              }
            }}
          />
        </div>
        <div id="button">
          <Button id="Button" type="button" onClick={() => envioMensagem()}>
            Enviar
          </Button>
        </div>
      </div>
    </Content>
  );
}

export default InputEnviar;
